class ProductBeforeAfterComparisonSlider extends HTMLElement {
  constructor() {
    super();
  }

  // Callback invoked when the element is connected to the DOM.
  connectedCallback() {
    this.section = this;
    this.rangeSlider = this.section.querySelector("#range-slider");
    this.beforeSlider = this.section.querySelector(
      "#comparison-slider--before"
    );

    this.dividerLine = this.section.querySelector("#divider-line");

    this.rangeSlider.addEventListener(
      "input",
      this.rangeSliderEventHandler.bind(this)
    );
  }

  // Callback invoked when the element is disconnected from the DOM.
  disconnectedCallback() {
    this.rangeSlider.removeEventListener(
      "input",
      this.rangeSliderEventHandler.bind(this),
      true
    );
  }

  /**
   * Event handler for the input event on the range slider.
   * Updates the width of the "before" slider and the position of the divider line.
   * @param {Event} event - The input event object.
   */
  rangeSliderEventHandler(event) {
    const { value } = event.target;
    this.updateBeforeSliderWidth(value);
    this.updateDividerLinePosition(value);
  }

  /**
   * Updates the width of the "before" slider based on the provided value.
   * @param {number} value - The value from the range slider (percentage).
   */
  updateBeforeSliderWidth(value) {
    this.beforeSlider.style.width = `${value}%`;
  }

  /**
   * Updates the position of the divider line based on the provided value.
   * @param {number} value - The value from the range slider (percentage).
   */
  updateDividerLinePosition(value) {
    this.dividerLine.style.transform = `translateX(-${value}%)`;
    this.dividerLine.style.left = `${value}%`;
  }
}

customElements.define(
  "product-before-after-comparison-slider",
  ProductBeforeAfterComparisonSlider
);

class ProductBeforeAfterSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.section = this;
    this.swiperEl = this.section.querySelector(".swiper");
    this.pagination = this.section.querySelector(".swiper-pagination");

    this.counterImages = this.section.querySelectorAll("img").length;

    if (this.counterImages > 1) this.initSlider();
  }

  initSlider() {
    import(flu.chunks.swiper).then((_ref) => {
      let { Swiper, Pagination } = _ref;
      this.slider = new Swiper(this.swiperEl, {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 4,
        resistance: false,
        loop: true,
        pagination: {
          el: this.pagination,
          type: "bullets",
          bulletElement: "span",
          bulletClass: "swiper-pagination-bullet",
          clickable: true,
        },
      });
    });
  }
}
customElements.define("product-before-after-slider", ProductBeforeAfterSlider);
